// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__en_M3","delete":"styles_delete__371Dz","update":"styles_update__1KHO6","add":"styles_add__2Kmsy"};